import React from 'react';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import { ViewTitle } from 'admin-on-rest/lib/mui';
import HelpIcon from 'material-ui/svg-icons/action/help';
import {dashStyles} from "../shared/styles-dashboard";

export default () => (
    <div>
        <Card style={{...dashStyles.dash, ...dashStyles.marginBottom}}>
            <HelpIcon style={dashStyles.dashIcon}/>
            <ViewTitle title="Frequently Asked Questions"/>
            <CardText>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                deserunt mollit anim id est laborum.
            </CardText>
        </Card>
        <Card style={{...dashStyles.dash, ...dashStyles.marginBottom}}>
            <CardHeader
                title="Locations"
                subtitle="Navigating Locations"
                actAsExpander={true}
                showExpandableButton={true}
            />
            <CardText expandable={true}>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                deserunt mollit anim id est laborum.
            </CardText>
        </Card>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/Help/index.js